import { render, staticRenderFns } from "./UserEmptyPhoneWindow.vue?vue&type=template&id=a51a6cc6&scoped=true"
import script from "./UserEmptyPhoneWindow.vue?vue&type=script&lang=js"
export * from "./UserEmptyPhoneWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51a6cc6",
  null
  
)

export default component.exports